import React, { useState } from "react";
import { STICKER_PACKS } from "../constants/stickers";
import { buttonStyle, panelHeading } from "../styles/ui";

// Bảng hình dán: hàng tab chọn gói ở trên, lưới hình dán bên dưới.
export default function StickerPanel({ onAdd, onDelete, hasSelection }) {
    const [packId, setPackId] = useState(STICKER_PACKS[0].id);
    const pack = STICKER_PACKS.find(p => p.id === packId) || STICKER_PACKS[0];

    return (
        <div style={{ width: "100%" }}>
            <div style={panelHeading}>🎀 Hình dán</div>

            <div style={tabRow}>
                {STICKER_PACKS.map(p => (
                    <button
                        key={p.id}
                        type="button"
                        title={p.label}
                        aria-label={p.label}
                        aria-pressed={p.id === packId}
                        onClick={() => setPackId(p.id)}
                        style={p.id === packId ? { ...tab, ...tabActive } : tab}
                    >
                        {p.icon}
                    </button>
                ))}
            </div>

            <div style={packLabel}>{pack.label}</div>

            <div style={grid}>
                {pack.items.map(item => (
                    <button
                        key={item.id}
                        type="button"
                        onClick={() => onAdd(item)}
                        style={cell}
                    >
                        {item.kind === "emoji" ? (
                            <span style={{ fontSize: 26, lineHeight: 1 }}>{item.char}</span>
                        ) : (
                            <img src={item.src} alt="" style={cellImage} />
                        )}
                    </button>
                ))}
            </div>

            {/* Nút xoá riêng: trên màn cảm ứng không có phím Delete */}
            <button
                type="button"
                onClick={onDelete}
                disabled={!hasSelection}
                style={{
                    ...buttonStyle,
                    marginTop: 12,
                    fontSize: 16,
                    padding: "6px 14px",
                    opacity: hasSelection ? 1 : 0.4,
                    cursor: hasSelection ? "pointer" : "default"
                }}
            >
                🗑 Xoá hình dán
            </button>
        </div>
    );
}

const tabRow = {
    display: "flex",
    flexWrap: "wrap",
    gap: 5
};

// 10 gói × 34px + 9 khoảng × 5px = 385px, vừa đúng cột 400px nên hàng tab
// không bị rớt xuống dòng thứ hai.
const tab = {
    width: 34,
    height: 34,
    fontSize: 18,
    lineHeight: 1,
    padding: 0,
    background: "white",
    border: "2px solid #e2c8bf",
    borderRadius: 10,
    cursor: "pointer",
    transition: "background 0.15s ease, border-color 0.15s ease"
};

const tabActive = {
    borderColor: "#ff7aa2",
    background: "#fff0f4"
};

const packLabel = {
    margin: "10px 0 6px",
    fontFamily: "Broline",
    fontSize: 15,
    color: "#b48a7c"
};

const grid = {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: 6
};

const cell = {
    height: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    background: "white",
    border: "2px solid #f0e0da",
    borderRadius: 10,
    cursor: "pointer"
};

const cellImage = {
    width: 28,
    height: 28,
    objectFit: "contain"
};
